import profileActions from "actions/profile";
import { connect } from "helpers/redux";

export default function (Component) {
    const mapState = (state) => ({
        profile: state.profile.profile,
        organization: state.profile.organization,
        roles: state.profile.roles,
    });

    const mapDispatch = (dispatch) => ({
        getOrg: () => dispatch(profileActions.getOrg()),
    });

    return connect(mapState, mapDispatch)(Component);
}
